import type { AttackAnimation, Bomb, EntityId, Shield, Weapon } from '../types';
import { SkillType } from '../model/skills';
import { dmg } from '../model/game';
import * as attack from './attacks';
import type { AnimationResult } from '../model/animations';

const disabled = true;

export const animations: Record<AttackAnimation, AnimationResult[]> = {
  swing_pickaxe: [{ ticks: 70, hits: [43] }],
  spear_throw: [{ ticks: 52, hits: [25] }],
  spear_poke: [{ ticks: 34, hits: [18] }],
  throw_bomb: [{ ticks: 32, hits: [23] }],
  knife_stab: [
    { ticks: 22, hits: [10] },
    { ticks: 29, hits: [15] },
    { ticks: 36, hits: [14] },
  ],
  knife_secondary: [{ ticks: 76, hits: [44] }],
  dual_knives: [
    { ticks: 25, hits: [9] },
    { ticks: 25, hits: [9] },
    { ticks: 36, hits: [8] },
  ],
  dual_knives_secondary: [{ ticks: 83, hits: [42] }],
  swing_axe: [
    { ticks: 48, hits: [29] },
    { ticks: 40, hits: [27] },
    { ticks: 41, hits: [30] },
  ],
  axe_secondary: [{ ticks: 100, hits: [57] }],
  unarmed_attack: [
    { ticks: 38, hits: [22] },
    { ticks: 36, hits: [24] },
  ],
  unarmed_kick: [{ ticks: 74, hits: [23] }],
  swing_sledge: [{ ticks: 85, hits: [58] }],
  swing_longsword: [
    { ticks: 43, hits: [23] },
    { ticks: 35, hits: [13] },
    { ticks: 45, hits: [17] },
  ],
  sword_secondary: [{ ticks: 92, hits: [48] }],
  greatsword: [
    { ticks: 48, hits: [31] },
    { ticks: 41, hits: [25] },
    { ticks: 83, hits: [32] },
  ],
  greatsword_secondary: [{ ticks: 108, hits: [48] }],
  mace_secondary: [{ ticks: 86, hits: [58] }],
  battleaxe_attack: [
    { ticks: 79, hits: [51] },
    { ticks: 46, hits: [16] },
    { ticks: 35, hits: [22] },
  ],
  battleaxe_secondary: [{ ticks: 42, hits: [20] }],
  atgeir_attack: [
    { ticks: 42, hits: [24] },
    { ticks: 43, hits: [28] },
    { ticks: 64, hits: [31] },
  ],
  atgeir_secondary: [{ ticks: 78, hits: [29] }],
  bow_aim: [{ ticks: 125, hits: [] }],
  bow_fire: [{ ticks: 30, hits: [9] }],
  reload_crossbow: [{ ticks: 175, hits: [] }],
  crossbow_fire: [{ ticks: 26, hits: [1] }],
  staff_rapidfire: [{ ticks: 11, hits: [3] }],
  staff_fireball: [
    { ticks: 43, hits: [25] },
    { ticks: 39, hits: [24] },
  ],
  staff_summon: [{ ticks: 68, hits: [9] }],
  dualaxes: [
    { ticks: 21, hits: [11] },
    { ticks: 35, hits: [19] },
    { ticks: 52, hits: [17, 36] },
    { ticks: 73, hits: [19, 35] },
  ],
  dualaxes_secondary: [{ ticks: 96, hits: [46] }],
  staff_lightningshot: [{ ticks: 41, hits: [27] }],
  recharge_lightningstaff: [{ ticks: 0, hits: [] }],
};
// bow_aim_recoil: 21


function variations(main: Weapon, options: Record<EntityId, Partial<Weapon>>): Weapon[] {
  return [
    main,
    ...Object.entries(options)
      .map(([id, override]) => ({ ...main, id, ...override }))
  ];
}

export const items: (Weapon | Shield | Bomb)[] = [
// PRE-CRAFT AGE
  {
    type: 'weapon', slot: 'both',
    id: 'PlayerUnarmed',
    emoji: '👊',
    tier: 0,
    stack: 0,
    maxLvl: 1,
    weight: 0,
    moveSpeed: 0,
    block: 2,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Unarmed,
    damage: [dmg({ blunt: 5 }), dmg({})],
    knockback: 40,
    backstab: 4,
    attacks: [attack.unarmed_attack(4), attack.kick(20)],
    durability: [Infinity, 0],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'Tankard',
    emoji: '🍺',
    tier: 2,
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 4,
    parryForce: [5, 0],
    parryBonus: 1.5,
    skill: null,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 4,
    attacks: [],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'TankardOdin',
    dlc: 'beta',
    emoji: '📯',
    tier: 2,
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 4,
    parryForce: [5, 0],
    parryBonus: 1.5,
    skill: null,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 4,
    attacks: [],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'TankardAnniversary',
    emoji: '📯',
    tier: 2,
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 4,
    parryForce: [5, 0],
    parryBonus: 1.5,
    skill: null,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 4,
    attacks: [],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'Tankard_dvergr',
    emoji: '🍺',
    tier: 2,
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 4,
    parryForce: [5, 0],
    parryBonus: 1.5,
    skill: null,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 4,
    attacks: [],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'Club',
    emoji: '🏏',
    tier: 0,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 12 }), dmg({ blunt: 6 })],
    knockback: 30,
    backstab: 3,
    attacks: [attack.swing_longsword(6)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeStone',
    emoji: '🪓',
    tier: 0,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 0,
    damage: [
      dmg({ slash: 15, chop: 20 }),
      dmg({ slash: 5, chop: 3 }),
     ],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_axe(6), attack.axe_secondary(12)],
    durability: [100, 30],
  },
  {
    type: 'weapon', slot: 'either',
    id: 'Torch',
    // lightRadius: 2,
    PointLight: {
      color: '#FF9E7B',
      range: 10,
      intensity: 1.5,
    },
    emoji: '🔥',
    tier: 0,
    tags: ['fire'],
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 4, fire: 15 }), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [attack.swing_longsword(4)],
    durability: [20, 0],
    durabilityDrainPerSec: 30,
  },
  {
    type: 'weapon', slot: 'either',
    id: 'Sparkler',
    // lightRadius: 2,
    emoji: '🎇',
    tier: 1,
    tags: ['fire'],
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: 0,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [],
    durability: [8, 0],
    durabilityDrainPerSec: 30,
  },
// STONE AGE
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeFlint',
    emoji: '🪓',
    tier: 1,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 4,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 1,
    damage: [
      dmg({ slash: 20, chop: 30 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_axe(6), attack.axe_secondary(6)],
    durability: [100, 30],
  },
{
    type: 'weapon', slot: 'both',
    id: 'AxeEarly',
    emoji: '🪓',
    tier: 1,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 4,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 2,
    damage: [
      dmg({ slash: 30, chop: 35 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 20,
    backstab: 3,
    attacks: [attack.dualaxes(6), attack.dualaxes_secondary(12)],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeFlint',
    emoji: '🔪',
    tier: 1,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 5, pierce: 5 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [attack.knife_stab(4), attack.knife_secondary(12)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearFlint',
    emoji: '🍢',
    tier: 1,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 4,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 20 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [attack.spear_poke(6), attack.spear_throw(8)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'SledgeStagbreaker',
    emoji: '🔨',
    tier: 1,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.15,
    block: 4,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [
      dmg({ blunt: 20, pierce: 5 }),
      dmg({ blunt: 6 }),
    ],
    knockback: 150,
    backstab: 2,
    attacks: [attack.swing_sledge(12, true)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'Bow',
    emoji: '🏹',
    tier: 1,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [dmg({ pierce: 22 }), dmg({ pierce: 3 })],
    knockback: 0,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 35],
      projAcc: [20, 1],
      stamina: 0,
      adrenaline: 1,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
      draw: { animation: 'bow_aim', duration: 2.5, stamina: 4 },
    }],
    durability: [50, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeStone',
    emoji: '⛏️',
    disabled,
    tier: -1,
    stack: 1,
    maxLvl: 1,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: 0,
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 0,
    damage: [dmg({ pierce: 15, pickaxe: 15 }), dmg({})],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_pickaxe(4)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeAntler',
    emoji: '⛏️',
    tier: 1,
    stack: 1,
    maxLvl: 1,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 0,
    damage: [dmg({ pierce: 18, pickaxe: 18 }), dmg({})],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_pickaxe(6)],
    durability: [100, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldWood',
    emoji: '🛡️',
    tier: 1,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 4,
    weight: 4,
    moveSpeed: -0.05,
    block: [6, 6],
    parryForce: [20, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldWoodTower',
    emoji: '🛡️',
    floating: true,
    tier: 1,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 4,
    moveSpeed: -0.1,
    block: [10, 6],
    parryForce: [100, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
// BRONZE AGE
  {
    type: 'weapon', slot: 'primary',
    id: 'AtgeirWood',
    emoji: '🔱',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [40, 5],
    parryBonus: 2,
    skill: SkillType.Polearms,
    damage: [dmg({ pierce: 1 }), dmg({ pierce: 1 })],
    knockback: 40,
    backstab: 3,
    attacks: [attack.atgeir_attack(8), attack.atgeir_secondary(8)],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeWood',
    emoji: '🪓',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 1,
    damage: [
      dmg({ slash: 1, chop: 1 }),
      dmg({ slash: 1, chop: 1 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_axe(4), attack.axe_secondary(6)],
    durability: [125, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'BattleaxeWood',
    emoji: '🪓',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.15,
    block: 28,
    parryForce: [70, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 1,
    damage: [
      dmg({ slash: 1, chop: 1 }),
      dmg({ slash: 1, chop: 1 }),
    ],
    knockback: 70,
    backstab: 3,
    attacks: [attack.battleaxe_attack(8), attack.battleaxe_secondary(8)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeWood',
    emoji: '🔪',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 1, pierce: 1 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [attack.knife_stab(4), attack.knife_secondary(4)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'MaceWood',
    emoji: '🏏',
    tier: 2,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [30, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 1 }), dmg({ blunt: 1 })],
    knockback: 80,
    backstab: 3,
    attacks: [attack.swing_longsword(8), attack.mace_secondary(4)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'SledgeWood',
    emoji: '🔨',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.15,
    block: 12,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 1 }), dmg({ blunt: 1 })],
    knockback: 210,
    backstab: 2,
    attacks: [attack.swing_sledge(8)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearWood',
    emoji: '🍢',
    tier: 1,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 1 }), dmg({ pierce: 1 })],
    knockback: 20,
    backstab: 3,
    attacks: [attack.spear_poke(4), attack.spear_throw(4)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordWood',
    emoji: '🗡️',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [dmg({ slash: 1 }), dmg({ slash: 1 })],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(4), attack.sword_secondary(4)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'THSwordWood',
    emoji: '🗡️',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [dmg({ slash: 1 }), dmg({ slash: 1 })],
    knockback: 55,
    backstab: 3,
    attacks: [attack.greatsword(8), attack.greatsword_secondary(8)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'FistBjornClaw',
    emoji: '🍴',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: 0,
    block: [5, 1],
    parryForce: [10, 5],
    parryBonus: 6,
    skill: SkillType.Unarmed,
    toolTier: 3,
    damage: [
      dmg({ slash: 25 }),
      dmg({ slash: 4 }),
    ],
    knockback: 20,
    backstab: 6,
    attacks: [attack.claw_attack(6), attack.kick(20)],
    durability: [300, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeCopper',
    emoji: '🔪',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 12, pierce: 12 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [attack.knife_stab(6), attack.knife_secondary(18)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AtgeirBronze',
    emoji: '🔱',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.05,
    block: 16,
    parryForce: [40, 5],
    parryBonus: 2,
    skill: SkillType.Polearms,
    damage: [dmg({ pierce: 45 }), dmg({ pierce: 6 })],
    knockback: 30,
    backstab: 3,
    attacks: [attack.atgeir_attack(12), attack.atgeir_secondary(24)],
    durability: [125, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeBronze',
    emoji: '🪓',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 2,
    damage: [
      dmg({ slash: 40, chop: 40 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_axe(8), attack.axe_secondary(16)],
    durability: [125, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'MaceBronze',
    emoji: '🏏',
    tier: 2,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [30, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 35 }), dmg({ blunt: 6 })],
    knockback: 80,
    backstab: 3,
    attacks: [attack.swing_longsword(8), attack.mace_secondary(16)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearBronze',
    emoji: '🍢',
    tier: 2,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 35 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [attack.spear_poke(8), attack.spear_throw(10)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordBronze',
    emoji: '🗡️',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    moveSpeed: -0.05,
    block: 12,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [dmg({ slash: 35 }), dmg({ slash: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(8), attack.sword_secondary(16)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeBronze',
    emoji: '⛏️',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 1,
    damage: [
      dmg({ pierce: 25, pickaxe: 25 }),
      dmg({ pierce: 5, pickaxe: 4 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_pickaxe(8)],
    durability: [120, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'BowFineWood',
    emoji: '🏹',
    tier: 2,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    floating: true,
    skill: SkillType.Bows,
    damage: [dmg({ pierce: 32 }), dmg({ pierce: 3 })],
    knockback: 5,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 50],
      projAcc: [20, 1],
      stamina: 0,
      adrenaline: 1,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
      draw: { animation: 'bow_aim', duration: 2.5, stamina: 6 },
    }],
    durability: [100, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBronzeBuckler',
    emoji: '🛡️',
    tier: 2,
    stack: 1,
    maxLvl: 3,
    weight: 3,
    moveSpeed: -0.05,
    block: [16, 6],
    parryForce: 30,
    parryBonus: 2.5,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBoneTower',
    emoji: '🛡️',
    floating: true,
    tier: 2,
    stack: 1,
    maxLvl: 3,
    weight: 4,
    moveSpeed: -0.1,
    block: [32, 6],
    parryForce: [100, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
// IRON AGE
  {
    type: 'bomb', slot: 'primary',
    id: 'BombOoze',
    emoji: '💣',
    tier: 3,
    stack: 50,
    maxLvl: 1,
    weight: 0.3,
    // radius: 4, ttl: 10, interval: 1
    // oozebomb_projectile
    spawns: 'oozebomb_explosion',
    stamina: 8,
  },
  {
    type: 'bomb', slot: 'primary',
    id: 'BombBlob_Poison',
    emoji: '💣',
    tier: 3,
    stack: 50,
    weight: 0.3,
    // BombBlob_Poison_projectile
    spawns: 'Blob',
    stamina: 8,
  },
  {
    type: 'bomb', slot: 'primary',
    id: 'BombBlob_PoisonElite',
    emoji: '💣',
    tier: 4,
    stack: 50,
    weight: 0.3,
    // BombBlob_PoisonElite_projectile
    spawns: 'BlobElite',
    stamina: 8,
  },
  {
    type: 'weapon', slot: 'both',
    id: 'Battleaxe',
    emoji: '🪓',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.15,
    block: 28,
    parryForce: [70, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 3,
    damage: [
      dmg({ slash: 70, chop: 40 }),
      dmg({ slash: 6, chop: 2.5 }),
    ],
    knockback: 70,
    backstab: 3,
    attacks: [attack.battleaxe_attack(16), attack.battleaxe_secondary(8)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordIron',
    // lightRadius: 2,
    emoji: '🗡️',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    toolTier: 0,
    damage: [dmg({ slash: 55 }), dmg({ slash: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(10), attack.sword_secondary(20)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeIron',
    emoji: '🪓',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 3,
    damage: [
      dmg({ slash: 60, chop: 50 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_axe(10), attack.axe_secondary(20)],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'SledgeIron',
    emoji: '🔨',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.15,
    block: 28,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 55 }), dmg({ blunt: 6 })],
    knockback: 200,
    backstab: 2,
    attacks: [attack.swing_sledge(20)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'MaceIron',
    emoji: '🏏',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [30, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 55 }), dmg({ blunt: 6 })],
    knockback: 90,
    backstab: 3,
    attacks: [attack.swing_longsword(10), attack.mace_secondary(20)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearElderbark',
    emoji: '🍢',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 55 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [attack.spear_poke(10), attack.spear_throw(12)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeIron',
    emoji: '⛏️',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 2,
    damage: [
      dmg({ pierce: 33, pickaxe: 33 }),
      dmg({ pierce: 5, pickaxe: 5 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_pickaxe(10)],
    durability: [150, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'AtgeirIron',
    emoji: '🔱',
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.05,
    block: 28,
    parryForce: [40, 5],
    parryBonus: 2,
    skill: SkillType.Polearms,
    damage: [dmg({ pierce: 65 }), dmg({ pierce: 6 })],
    knockback: 30,
    backstab: 3,
    attacks: [attack.atgeir_attack(14), attack.atgeir_secondary(28)],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'BowHuntsman',
    emoji: '🏹',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [dmg({ pierce: 42 }), dmg({ pierce: 3 })],
    knockback: 10,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 50],
      projAcc: [20, 0],
      stamina: 0,
      adrenaline: 1,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 4,
      hitNoise: 4,
      range: 1,
      draw: { animation: 'bow_aim', duration: 2.5, stamina: 8 },
    }],
    durability: [100, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBanded',
    emoji: '🛡️',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 4,
    weight: 5,
    moveSpeed: -0.05,
    block: [42, 6],
    parryForce: [40, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldIronTower',
    emoji: '🛡️',
    floating: true,
    tier: 3,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 4,
    moveSpeed: -0.1,
    block: [52, 6],
    parryForce: [100, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    durability: [200, 50],
    knockback: 40,
    backstab: 4,
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldIronBuckler',
    emoji: '🛡️',
    floating: true,
    tier: 3,
    stack: 1,
    maxLvl: 3,
    weight: 4,
    moveSpeed: -0.05,
    block: [28, 6],
    parryForce: 30,
    parryBonus: 2.5,
    skill: SkillType.Blocking,
    durability: [200, 50],
    knockback: 40,
    backstab: 4,
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldSerpentscale',
    emoji: '🛡️',
    tier: 3,
    floating: true,
    stack: 1,
    maxLvl: 3,
    weight: 5,
    moveSpeed: -0.15,
    block: [60, 6],
    parryForce: [100, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    damageModifiers: { pierce: 'resistant' },
    durability: [250, 50],
    knockback: 50,
    backstab: 4,
  },
// SILVER AGE
  {
    type: 'bomb', slot: 'primary',
    id: 'BombBlob_Frost',
    emoji: '💣',
    tier: 4,
    stack: 50,
    weight: 0.3,
    // BombBlob_Frost_projectile
    spawns: 'BlobFrost',
    stamina: 8,
  },
  {
    type: 'weapon', slot: 'both',
    id: 'FistFenrirClaw',
    emoji: '🍴',
    tier: 4,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: 0,
    block: [5, 1],
    parryForce: [10, 5],
    parryBonus: 6,
    skill: SkillType.Unarmed,
    toolTier: 0,
    damage: [
      dmg({ slash: 60 }),
      dmg({ slash: 4 }),
    ],
    knockback: 20,
    backstab: 6,
    attacks: [attack.claw_attack(10), attack.kick(20)],
    durability: [300, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'BattleaxeCrystal',
    emoji: '🪓',
    tier: 4,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    PointLight: { color: '#A8D3FF', range: 3, intensity: 1 },
    moveSpeed: -0.15,
    block: 40,
    parryForce: [70, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 3,
    damage: [
      dmg({ slash: 90, chop: 50, spirit: 30 }),
      dmg({ slash: 6, chop: 2.5 }),
    ],
    knockback: 70,
    backstab: 3,
    attacks: [attack.battleaxe_attack(18), attack.battleaxe_secondary(9)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordSilver',
    emoji: '🗡️',
    tier: 4,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    moveSpeed: -0.05,
    block: 30,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [
      dmg({ slash: 75, spirit: 30 }),
      dmg({ slash: 6, spirit: 5 }),
    ],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(12), attack.sword_secondary(24)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearWolfFang',
    emoji: '🍢',
    tier: 4,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 30,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 75 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [attack.spear_poke(12), attack.spear_throw(14)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'MaceSilver',
    emoji: '🔨',
    tier: 4,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 30,
    parryForce: [30, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [
      dmg({ blunt: 35, frost: 40, spirit: 20 }),
      dmg({ frost: 6 }),
    ],
    knockback: 120,
    backstab: 3,
    attacks: [attack.swing_longsword(12), attack.mace_secondary(24)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearChitin',
    emoji: '🍢',
    tier: 2,
    floating: true,
    special: 'harpoon',
    stack: 1,
    maxLvl: 1,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 10 }), dmg({})],
    knockback: 20,
    backstab: 1,
    attacks: [attack.spear_throw(15)],
    durability: [50, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeChitin',
    emoji: '🔪',
    tier: 2,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 20, pierce: 20 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [attack.knife_stab(8), attack.knife_secondary(24)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeSilver',
    emoji: '🔪',
    tier: 4,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 25, pierce: 25, spirit: 12 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [attack.knife_stab(10), attack.knife_secondary(30)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'BowDraugrFang',
    emoji: '🏹',
    tier: 4,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [
      dmg({ pierce: 47, poison: 5 }),
      dmg({ pierce: 3, poison: 5 }),
    ],
    knockback: 20,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 60],
      projAcc: [20, 0],
      stamina: 0,
      adrenaline: 1,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
      draw: { animation: 'bow_aim', duration: 2.5, stamina: 10 },
    }],
    durability: [100, 50],
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldSilver',
    emoji: '🛡️',
    tier: 4,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 5,
    moveSpeed: -0.05,
    block: [60, 6],
    parryForce: [40, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
// BLACK AGE
  {
    type: 'bomb', slot: 'primary',
    id: 'BombBlob_Tar',
    emoji: '💣',
    tier: 5,
    stack: 50,
    weight: 0.3,
    // BombBlob_Tar_projectile
    spawns: 'BlobTar',
    stamina: 8,
  },
  {
    type: 'weapon', slot: 'both',
    id: 'FistBjornUndeadClaw',
    emoji: '🍴',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: 0,
    block: [5, 1],
    parryForce: [10, 5],
    parryBonus: 6,
    skill: SkillType.Unarmed,
    toolTier: 3,
    damage: [
      dmg({ slash: 20, pierce: 60 }),
      dmg({ slash: 4 }),
    ],
    knockback: 20,
    backstab: 6,
    attacks: [attack.claw_attack(12), attack.kick(20)],
    durability: [300, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'AtgeirBlackmetal',
    emoji: '🔱',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.05,
    block: 52,
    parryForce: [40, 5],
    parryBonus: 2,
    skill: SkillType.Polearms,
    damage: [dmg({ pierce: 105 }), dmg({ pierce: 6 })],
    knockback: 30,
    backstab: 3,
    attacks: [attack.atgeir_attack(18), attack.atgeir_secondary(36)],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeBlackMetal',
    emoji: '🪓',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 39,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 4,
    damage: [
      dmg({ slash: 100, chop: 60 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 60,
    backstab: 3,
    attacks: [attack.swing_axe(14), attack.axe_secondary(28)],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'BattleaxeBlackmetal',
    emoji: '🪓',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.15,
    block: 52,
    parryForce: [70, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 4,
    damage: [
      dmg({ slash: 110, chop: 60 }),
      dmg({ slash: 6, chop: 2.5 }),
    ],
    knockback: 70,
    backstab: 3,
    attacks: [attack.battleaxe_attack(20), attack.battleaxe_secondary(10)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'PickaxeBlackMetal',
    emoji: '⛏️',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 2,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Pickaxes,
    toolTier: 3,
    damage: [
      dmg({ pierce: 49, pickaxe: 49 }),
      dmg({ pierce: 5, pickaxe: 5 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [attack.swing_pickaxe(14)],
    durability: [210, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'KnifeBlackMetal',
    emoji: '🔪',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 2,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 34, pierce: 34 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [attack.knife_stab(12), attack.knife_secondary(36)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordBlackmetal',
    emoji: '🗡️',
    tier: 5,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    moveSpeed: -0.05,
    block: 39,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [dmg({ slash: 95 }), dmg({ slash: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(14), attack.sword_secondary(28)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'MaceNeedle',
    emoji: '🏏',
    tier: 5,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    PointLight: { color: '#38FFC5', range: 3, intensity: 1 },
    moveSpeed: -0.05,
    block: 39,
    parryForce: [30, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [
      dmg({ blunt: 50, pierce: 45 }),
      dmg({ pierce: 6 }),
    ],
    knockback: 100,
    backstab: 3,
    attacks: [attack.swing_longsword(14), attack.mace_secondary(28)],
    durability: [150, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'BowSpineSnap',
    PointLight: { color: '#DB1827', range: 7, intensity: 1.2 },
    emoji: '🏹',
    tier: 6,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [
      dmg({ pierce: 72, spirit: 5 }),
      dmg({ pierce: 4, spirit: 5 }),
    ],
    knockback: 25,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 60],
      projAcc: [20, 0],
      stamina: 0,
      adrenaline: 1,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
      draw: { animation: 'bow_aim', duration: 2.5, stamina: 14 },
    }],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'bow',
    id: 'CrossbowArbalest',
    emoji: '🏹',
    tier: 5,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Crossbows,
    damage: [
      dmg({ pierce: 200 }),
      dmg({ pierce: 3 }),
    ],
    knockback: 200,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'crossbow_fire',
      projVel: [0, 200],
      projAcc: [1, 0],
      stamina: 0,
      adrenaline: 1,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
      reload: { animation: 'reload_crossbow', time: 3.5, stamina: 1 },
    }],
    durability: [50, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBlackmetal',
    emoji: '🛡️',
    tier: 5,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 5,
    moveSpeed: -0.05,
    block: [78, 6],
    parryForce: [50, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldBlackmetalTower',
    emoji: '🛡️',
    tier: 5,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 7,
    weight: 5,
    moveSpeed: -0.1,
    block: [104, 6],
    parryForce: [150, 5],
    parryBonus: 0,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
// MISTLANDS
  {
    type: 'bomb', slot: 'primary',
    id: 'BombBile',
    emoji: '💣',
    tier: 6,
    stack: 50,
    weight: 0.3,
    // bilebomb_projectile
    // bilebomb_explosion
    spawns: 'bilebomb_explosion',
    stamina: 8,
  },
  {
    type: 'weapon', slot: 'either',
    id: 'Lantern',
    group: 'torch',
    emoji: '🏮',
    tier: 6,
    tags: ['fire'],
    stack: 1,
    maxLvl: 1,
    weight: 2,
    PointLight: { color: '#FFC849', range: 8, intensity: 1.5 },
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 4, fire: 15 }), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [],
    durability: [200, 0],
  },
  {
    type: 'weapon', slot: 'either',
    id: 'TorchMist',
    disabled,
    PointLight: { color: '#7BCDFF', range: 10, intensity: 1.5 },
    demister: 6,
    // warmthRadius: 2,
    group: 'demist',
    emoji: '🔥',
    tier: 6,
    tags: ['fire'],
    stack: 1,
    maxLvl: 1,
    weight: 1,
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 4, fire: 15 }), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [attack.swing_longsword(4)],
    durability: [20, 0],
    durabilityDrainPerSec: 30,
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffIceShards',
    emoji: '❄',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    PointLight: { color: '#2AE2FF', range: 3, intensity: 1.5 },
    moveSpeed: -0.10,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    damage: [dmg({ frost: 30 }), dmg({ frost: 2 })],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'staff_rapidfire',
      projVel: [30, 30],
      projAcc: [5, 0],
      raiseSkillAmount: 0.2,
      stamina: 0,
      adrenaline: 1,
      eitr: 5,
      walkSpeed: 0.5,
      rotationSpeed: 1,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffFireball',
    emoji: '🔥',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    PointLight: { color: '#FF762A', range: 3, intensity: 1.5 },
    moveSpeed: -0.10,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    damage: [dmg({ fire: 60, blunt: 40 }), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'staff_fireball',
      projVel: [30, 30],
      projAcc: [5, 0],
      stamina: 0,
      adrenaline: 3,
      eitr: 35,
      walkSpeed: 0.5,
      rotationSpeed: 1,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffSkeleton',
    emoji: '💀',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    PointLight: { color: '#DC25E2', range: 4, intensity: 1 },
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 1.5,
    skill: SkillType.BloodMagic,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'summon',
      animation: 'staff_summon',
      stamina: 0,
      adrenaline: 0,
      eitr: 100,
      healthPercent: 40,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
      summons: 'Skeleton_Friendly',
      skillFactor: 0.02,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffShield',
    emoji: '🛡',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 1.5,
    skill: SkillType.BloodMagic,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'cast',
      animation: 'staff_summon',
      stamina: 0,
      adrenaline: 6,
      eitr: 60,
      healthPercent: 40,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
      id: 'Staff_shield',
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'AtgeirHimminAfl',
    emoji: '🔱',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    // always, not only equipped:
    PointLight: { color: '#3AB9D6', range: 7, intensity: 1 },
    moveSpeed: -0.05,
    block: 64,
    parryForce: [40, 5],
    parryBonus: 2,
    skill: SkillType.Polearms,
    damage: [dmg({ pierce: 85, lightning: 40 }), dmg({ lightning: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [attack.atgeir_attack(20), attack.atgeir_secondary(40)],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'AxeJotunBane',
    emoji: '🪓',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    PointLight: { color: '#DBAA18', range: 7, intensity: 1 },
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 4,
    damage: [
      dmg({ slash: 80, chop: 70, poison: 40 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 60,
    backstab: 3,
    attacks: [attack.swing_axe(16), attack.axe_secondary(32)],
    durability: [175, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'BattleaxeSkullSplittur',
    emoji: '🪓',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 2.5,
    moveSpeed: -0.15,
    block: 64,
    parryForce: [70, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 4,
    damage: [
      dmg({ slash: 130, chop: 70 }),
      dmg({ slash: 6, chop: 2.5 }),
    ],
    knockback: 70,
    backstab: 3,
    attacks: [attack.battleaxe_attack(22), attack.battleaxe_secondary(11)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'KnifeSkollAndHati',
    emoji: '🔪',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: 0,
    block: 24,
    parryForce: [10, 5],
    parryBonus: 4,
    skill: SkillType.Knives,
    damage: [
      dmg({ slash: 45, pierce: 45 }),
      dmg({ slash: 1, pierce: 1 }),
    ],
    knockback: 10,
    backstab: 6,
    attacks: [{
      type: 'melee',
      animation: 'dual_knives',
      chain: 3,
      chainCombo: 2,
      stamina: 14,
      adrenaline: 1,
      walkSpeed: 0.3,
      rotationSpeed: 1,
      startNoise: 1,
      hitNoise: 5,
      range: 1.8,
    }, {
      type: 'melee',
      animation: 'dual_knives_secondary',
      chain: 0,
      chainCombo: 2,
      stamina: 42,
      adrenaline: 2,
      walkSpeed: 0,
      rotationSpeed: 0,
      startNoise: 2,
      hitNoise: 5,
      range: 1.8,
      mul: { damage: 3, force: 4, stagger: 1 },
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordMistwalker',
    emoji: '🗡️',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    demister: 5,
    PointLight: { color: '#7BCDFF', range: 6, intensity: 1 },
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [
      dmg({ slash: 75, frost: 40 }),
      dmg({ frost: 6, spirit: 5 }),
    ],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(16), attack.sword_secondary(32)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'THSwordKrom',
    emoji: '🗡️',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.05,
    block: 52,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [
      dmg({ slash: 150 }),
      dmg({ slash: 6 }),
    ],
    knockback: 55,
    backstab: 3,
    attacks: [attack.greatsword(20), attack.greatsword_secondary(40)],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SpearCarapace',
    emoji: '🍢',
    tier: 6,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 45,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    damage: [dmg({ pierce: 115 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [attack.spear_poke(16), attack.spear_throw(16)],
    durability: [100, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'SledgeDemolisher',
    emoji: '🔨',
    tier: 6,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.2,
    block: 56,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Clubs,
    damage: [dmg({ blunt: 145 }), dmg({ blunt: 6 })],
    knockback: 210,
    backstab: 2,
    attacks: [attack.swing_sledge(28)],
    durability: [100, 50],
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldCarapaceBuckler',
    emoji: '🛡️',
    tier: 6,
    floating: true,
    stack: 1,
    maxLvl: 3,
    weight: 5,
    moveSpeed: -0.05,
    block: [78, 6],
    parryForce: [50, 5],
    parryBonus: 2.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
  { type: 'shield', slot: 'secondary',
    id: 'ShieldCarapace',
    emoji: '🛡️',
    tier: 6,
    floating: true,
    stack: 1,
    maxLvl: 3,
    weight: 5,
    moveSpeed: -0.05,
    block: [96, 6],
    parryForce: [60, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    damage: [dmg({ blunt: 10 }), dmg({})],
    knockback: 50,
    backstab: 4,
    durability: [200, 50],
  },
// ASHLANDS
  {
    type: 'bomb', slot: 'primary',
    id: 'BombBlob_Lava',
    emoji: '💣',
    tier: 3,
    stack: 50,
    weight: 0.3,
    // BombBlob_Lava_projectile
    spawns: 'BlobLava',
    stamina: 8,
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffLightning',
    emoji: '⚡',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    // PointLight: { color: '#2AE2FF', range: 3, intensity: 1.5 },
    moveSpeed: -0.05,
    block: 3,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    damage: [dmg({ lightning: 20 }), dmg({ lightning: 3 })],
    knockback: 210,
    backstab: 1,
    attacks: [{
      type: 'proj',
      animation: 'recharge_lightningstaff',
      projVel: [0, 200],
      projAcc: [15, 0],
      number: 12,
      raiseSkillAmount: 0.1,
      stamina: 0,
      adrenaline: 6,
      reload: { animation: 'recharge_lightningstaff', time: 1.9, eitr: 25 },
      walkSpeed: 0.5,
      rotationSpeed: 1,
      startNoise: 15,
      hitNoise: 8,
      range: 2.4,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffClusterbomb',
    emoji: '🧨',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    // projectile: staff_clusterbombstaff_projectile
    // spawn on hit: staff_clusterbombstaff_splinter_projectile x12
    damage: [dmg({ blunt: 12, fire: 12 }), dmg({ fire: 6 })],
    toolTier: 5,
    knockback: 100,
    backstab: 1,
    attacks: [{
      type: 'proj',
      animation: 'staff_fireball',
      projVel: [2, 20],
      projAcc: [1, 0],
      number: 12,
      raiseSkillAmount: 0.1,
      stamina: 0,
      adrenaline: 3,
      eitr: 30,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 0,
      hitNoise: 0,
      range: 1,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffRedTroll',
    emoji: '👹',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    // PointLight: { color: '#DC25E2', range: 4, intensity: 1 },
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.BloodMagic,
    damage: [dmg({}), dmg({})],
    knockback: 30,
    backstab: 3,
    attacks: [{
      type: 'summon',
      animation: 'staff_summon',
      stamina: 0,
      adrenaline: 12,
      eitr: 120,
      healthPercent: 40,
      walkSpeed: 0.3,
      rotationSpeed: 0.3,
      startNoise: 0,
      hitNoise: 0,
      range: 2.4,
      summons: 'Troll_Summoned',
      cantUseInDungeon: true,
      skillFactor: 0.02,
    }],
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'both',
    id: 'StaffGreenRoots',
    emoji: '🌿',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.3,
    moveSpeed: -0.05,
    block: 48,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.ElementalMagic,
    damage: [dmg({ blunt: 20, poison: 20 }), dmg({})],
    knockback: 30,
    backstab: 3,
    // staff_greenroots_projectile ->
    // staff_greenroots_spawn
    attacks: [{
      type: 'summon',
      summons: 'staff_greenroots_tentaroot',
      animation: 'staff_fireball',
      // projVel: [2, 20],
      // projAcc: [1, 0],
      skillFactor: 0.02,
      // raiseSkillAmount: 1,
      stamina: 0,
      adrenaline: 3,
      eitr: 55,
      walkSpeed: 0.2,
      rotationSpeed: 0.2,
      startNoise: 10,
      hitNoise: 30,
      range: 2.4,
    }],
    durability: [200, 50],
  },
  ...variations({
    type: 'weapon', slot: 'bow',
    id: 'BowAshlands',
    emoji: '🏹',
    tier: 7,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Bows,
    damage: [dmg({ pierce: 82 }), dmg({ pierce: 4, spirit: 5 })],
    knockback: 25,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'bow_fire',
      projVel: [2, 60],
      projAcc: [20, 0],
      stamina: 0,
      adrenaline: 2,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
      draw: { animation: 'bow_aim', duration: 2.5, stamina: 14 },
    }],
    durability: [100, 50],
  }, {
    'BowAshlandsBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'BowAshlandsLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ pierce: 82, lightning: 10 }),
        dmg({ pierce: 4, spirit: 5 }),
      ],
    },
    'BowAshlandsNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ pierce: 82, poison: 10 }),
        dmg({ pierce: 4, spirit: 5 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'bow',
    id: 'CrossbowRipper',
    emoji: '🏹',
    tier: 7,
    floating: true,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 3,
    parryForce: 0,
    parryBonus: 1.5,
    skill: SkillType.Crossbows,
    toolTier: 5,
    damage: [
      dmg({ pierce: 220 }),
      dmg({ pierce: 3 }),
    ],
    knockback: 210,
    backstab: 3,
    attacks: [{
      type: 'proj',
      animation: 'crossbow_fire',
      projVel: [0, 200],
      projAcc: [0, 0],
      stamina: 0,
      adrenaline: 2,
      walkSpeed: 0.3,
      rotationSpeed: 0,
      startNoise: 15,
      hitNoise: 8,
      range: 1,
      reload: { animation: 'reload_crossbow', time: 3.5, stamina: 1 },
    }],
    durability: [50, 50],
  }, {
    'CrossbowRipperBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'CrossbowRipperLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ pierce: 220, lightning: 10 }),
        dmg({ pierce: 3 }),
      ],
    },
    'CrossbowRipperNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ pierce: 220, poison: 10 }),
        dmg({ pierce: 3 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'primary',
    id: 'SpearSplitner',
    emoji: '🍢',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 1.5,
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Spears,
    toolTier: 5,
    damage: [ dmg({ pierce: 135 }), dmg({ pierce: 6 })],
    knockback: 20,
    backstab: 3,
    attacks: [attack.spear_poke(16), attack.spear_throw(18)],
    // blood: damageMultiplierPerMissingHP: 0.002
    // lightning: lightning: blunt-10, lightning +10, spawnOnHit: AoE ChainLightning 20% (lightning: 75)
    // nature: pierce -10, poison +10, 15% to immobilize
    durability: [100, 50],
  }, {
    'SpearSplitner_Blood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'SpearSplitner_Lightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ pierce: 135, lightning: 10 }),
        dmg({ pierce: 6, }),
      ],
    },
    'SpearSplitner_Nature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ pierce: 135, poison: 10 }),
        dmg({ pierce: 6, }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'both',
    id: 'AxeBerzerkr',
    emoji: '🪓',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Axes,
    toolTier: 6,
    damage: [
      dmg({ slash: 140, chop: 80 }),
      dmg({ slash: 5, chop: 3 }),
    ],
    knockback: 20,
    backstab: 3,
    attacks: [attack.dualaxes(16), attack.dualaxes_secondary(32)],
    durability: [175, 50],
  }, {
    'AxeBerzerkrBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'AxeBerzerkrLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ slash: 140, chop: 80, lightning: 10 }),
        dmg({ slash: 5, chop: 3 }),
      ],
    },
    'AxeBerzerkrNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ slash: 140, chop: 80, poison: 10 }),
        dmg({ slash: 5, chop: 3 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'primary',
    id: 'MaceEldner',
    emoji: '🍭',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 2,
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Clubs,
    toolTier: 6,
    damage: [
      dmg({ blunt: 135 }),
      dmg({ blunt: 6 }),
    ],
    knockback: 100,
    backstab: 3,
    attacks: [attack.swing_longsword(16), attack.mace_secondary(28)],
    durability: [150, 50],
  }, {
    'MaceEldnerBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'MaceEldnerLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ blunt: 135, lightning: 10 }),
        dmg({ blunt: 5 }),
      ],
    },
    'MaceEldnerNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ blunt: 135, poison: 10 }),
        dmg({ pierce: 5 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'primary',
    id: 'SwordNiedhogg',
    emoji: '🗡️',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [dmg({ slash: 135 }), dmg({ slash: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(16), attack.sword_secondary(28)],
    durability: [200, 50],
  }, {
    'SwordNiedhoggBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'SwordNiedhoggLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ slash: 135, lightning: 10 }),
        dmg({ slash: 5 }),
      ],
    },
    'SwordNiedhoggNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ slash: 135, poison: 10 }),
        dmg({ slash: 5 }),
      ],
    },
  }),
  ...variations({
    type: 'weapon', slot: 'both',
    id: 'THSwordSlayer',
    emoji: '🗡️',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.05,
    block: 64,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Swords,
    damage: [
      dmg({ slash: 170 }),
      dmg({ slash: 6 }),
    ],
    knockback: 50,
    backstab: 3,
    attacks: [attack.greatsword(20), attack.greatsword_secondary(40)],
    durability: [200, 50],
  }, {
    'THSwordSlayerBlood': {
      damageMultiplierPerMissingHP: 0.002,
    },
    'THSwordSlayerLightning': {
      hitEffect: { id: 'ChainLightning', chance: 0.25 },
      damage: [
        dmg({ slash: 170, lightning: 10 }),
        dmg({ slash: 5 }),
      ],
    },
    'THSwordSlayerNature': {
      hitEffect: { id: 'ImmobilizedAshlands', chance: 0.2 },
      damage: [
        dmg({ slash: 170, poison: 10 }),
        dmg({ slash: 5 }),
      ],
    },
  }),
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordDyrnwyn',
    emoji: '🗡️',
    tier: 7,
    stack: 1,
    maxLvl: 4,
    weight: 0.8,
    PointLight: { color: '#FF9300', range: 10, intensity: 1 },
    moveSpeed: -0.05,
    block: 57,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    toolTier: 6,
    damage: [
      dmg({ slash: 145, fire: 10 }),
      dmg({ slash: 6 }),
    ],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(16), attack.sword_secondary(28)],
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldFlametal',
    emoji: '🛡️',
    floating: true,
    tier: 7,
    stack: 1,
    maxLvl: 3,
    variants: 5,
    weight: 5,
    moveSpeed: -0.05,
    block: [114, 6],
    parryForce: [50, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldFlametalTower',
    emoji: '🛡️',
    tier: 7,
    floating: true,
    stack: 1,
    maxLvl: 3,
    variants: 5,
    weight: 5,
    moveSpeed: -0.1,
    block: [140, 6],
    parryForce: [150, 5],
    parryBonus: 1,
    skill: SkillType.Blocking,
    durability: [200, 50],
  },
  {
    type: 'bomb', slot: 'primary',
    id: 'BombSiege',
    emoji: '💣',
    tier: 7,
    stack: 50,
    weight: 0.3,
    // toolTier: 6,
    spawns: 'siegebomb_explosion',
    // { pickaxe: 600 }
    stamina: 8,
  },
  {
    type: 'bomb', slot: 'primary',
    id: 'BombLava',
    emoji: '💣',
    tier: 7,
    stack: 50,
    weight: 0.3,
    // toolTier: 4,
    // projectile: lavabomb_projectile ->
      // TTL = 20
      // projVel: [2, 20],
      // projAcc: [20, 5],
    // lavabomb_explosion ->
    // spawnOnHitTerrain (Lava): lavabomb_rock1
    spawns: 'lavabomb_rock1',
    stamina: 8,
  },
  {
    type: 'bomb', slot: 'primary',
    id: 'BombSmoke',
    emoji: '💣',
    tier: 7,
    stack: 50,
    weight: 0.3,
    // projectile: smokebomb_projectile TTL = 20
    // projVel: [2, 20],
    // projAcc: [20, 5],
    // smokebomb_explosion
    // spawnOnHit: SmokeBallBomb
    spawns: 'SmokeBallBomb',
    stamina: 8,
  },
  // MISC
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordIronFire',
    emoji: '🗡️',
    disabled, // it's enabled, but recipe is disabled
    tier: 3,
    stack: 1,
    maxLvl: 4,
    weight: 1,
    // warmthRadius: 2,
    PointLight: { color: '#FF9E7B', range: 5, intensity: 2 },
    moveSpeed: -0.05,
    block: 21,
    parryForce: [20, 5],
    parryBonus: 2,
    skill: SkillType.Swords,
    toolTier: 0,
    damage: [
      dmg({ slash: 55, fire: 30 }),
      dmg({ slash: 5, fire: 6 }),
    ],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(14), attack.sword_secondary(28)],
    durability: [200, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldKnight',
    emoji: '🛡️',
    disabled,
    tier: -1,
    floating: true,
    stack: 1,
    maxLvl: 1,
    weight: 4,
    moveSpeed: -0.05,
    block: [120, 6],
    parryForce: [40, 5],
    parryBonus: 1.5,
    skill: SkillType.Blocking,
    knockback: 200,
    backstab: 4,
    durability: [100, 50],
  },
  {
    type: 'shield', slot: 'secondary',
    id: 'ShieldIronSquare',
    emoji: '🛡️',
    disabled,
    tier: -1,
    floating: true,
    stack: 1,
    maxLvl: 3,
    weight: 4,
    moveSpeed: -0.2,
    block: [35, 6],
    parryForce: 30,
    parryBonus: 0,
    skill: SkillType.Blocking,
    knockback: 40,
    backstab: 4,
    durability: [200, 50],
  },
  {
    type: 'weapon', slot: 'primary',
    id: 'SwordCheat',
    emoji: '🗡️',
    disabled,
    tier: -1,
    stack: 1,
    maxLvl: 1,
    weight: 2,
    moveSpeed: -0.05,
    block: 10,
    parryForce: 0,
    parryBonus: 2,
    skill: SkillType.Swords,
    toolTier: 10,
    damage: [dmg({
      slash: 10000,
      chop: 10000,
      pickaxe: 10000,
    }), dmg({
    })],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_longsword(10), attack.sword_secondary(20)],
    durability: [100, 50], // useDurability: false
  },
  {
    type: 'weapon', slot: 'both',
    id: 'SledgeCheat',
    emoji: '🔨',
    disabled,
    tier: -1,
    stack: 1,
    maxLvl: 4,
    weight: 4,
    moveSpeed: -0.2,
    block: 15,
    parryForce: [50, 10],
    parryBonus: 2,
    skill: SkillType.Clubs,
    toolTier: 10,
    damage: [dmg({ /*damage: 99999, */ }), dmg({ blunt: 6 })],
    knockback: 40,
    backstab: 3,
    attacks: [attack.swing_sledge(25)],
    durability: [100, 50],
  },
];

for (const item of items) {
  if (item.components == null) item.components = [];
  item.components.push('ItemDrop');
}

const enabledWeapons = items.filter(w => !w.disabled && w.type === 'weapon') as Weapon[]; 
export const axes = enabledWeapons.filter(w => w.damage[0].chop);
export const pickaxes = enabledWeapons.filter(w => w.damage[0].pickaxe);
